export { default as ticketAPI } from './ticket';
export { default as resultsAPI } from './results';
export { default as upcomingEventsAPI } from './upcomingEvents';
export { default as lastTicketsAPI } from './lastTickets';
export { default as paytableAPI } from './paytable';
export { default as ws } from './ws';
export { default as staticAPI } from './gamesStatic';
